module.exports = __webpack_public_path__ + "img/dynamic-3.37b3cd92.png";